import { render, staticRenderFns } from "./UserChoose.vue?vue&type=template&id=bee703ae&scoped=true&"
import script from "./UserChoose.vue?vue&type=script&lang=js&"
export * from "./UserChoose.vue?vue&type=script&lang=js&"
import style0 from "./UserChoose.vue?vue&type=style&index=0&id=bee703ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee703ae",
  null
  
)

export default component.exports